import React from "react";
import "../css/style.css";
const Header = () => {
  return (
    <header className="header">
      <div className="wrapper">
        <div className="header_inr">
          <div className="logo_header">
            <a href="#.">
              <img src="images/oneClick_logo.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
